module.exports = __webpack_public_path__ + "static/img/marble-light.b2bf671.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/marble-light.gif
// module id = 2Zof
// module chunks = 0